import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Tooltip,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../../scss/Sigma/_headers_logs.scss';
import { useState } from 'react';

const CustomAccordion = ({ title, data }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Accordion
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <AccordionSummary
        expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
        aria-controls='custom-accordion-content'
        id='custom-accordion-header'
        sx={{
          '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: '8px',
            order: -1,
          },
        }}
      >
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box className='info-grid'>
          {data.map(({ label, value, parseFunction }) => {
            let displayValue = value;

            if (parseFunction) {
              try {
                displayValue = parseFunction(value);
              } catch (error) {
                displayValue = 'Error al procesar el valor';
              }
            }

            return (
              <Box key={label} className='info-item'>
                <Typography variant='caption' className='info-label'>
                  {label}
                </Typography>
                <Tooltip title={displayValue || '...'}>
                  <Typography className='info-value'>
                    {displayValue || '...'}
                  </Typography>
                </Tooltip>
              </Box>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
